import { useModal } from '@ebay/nice-modal-react';
import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { useConfiguration } from '@ocx/data-configuration';
import { SupportLink } from '@ocx/feat-support';
import { AuthMethod } from '@ocx/graphql';
import { Button, Typography, SizingMultiplier } from '@ocx/ui';
import { ModalDrawer } from '@ocx/ui-modals';

import { messages } from './sms-opt-in-failed-popup.messages';
import { createSmsOptInLink } from '../../sms-opted-out-warning.utils';

export const SmsOptInFailedPopupController = () => {
  const { visible, hide, remove } = useModal();
  const { smsOptInKeyword, smsOptInPhoneNumber } = useConfiguration('smsOptedOutWarning');
  const { primaryMethod } = useConfiguration('auth');

  const smsOptInLink = createSmsOptInLink(smsOptInKeyword, smsOptInPhoneNumber);
  const authMethod = primaryMethod === AuthMethod.MagicLink ? 'link' : 'OTP';

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <Stack spacing={SizingMultiplier.lg} p={SizingMultiplier.lg} pt={SizingMultiplier.xl}>
        <Stack spacing={SizingMultiplier.md}>
          <Typography variant="h5" component="h1">
            <FormattedMessage {...messages['sms-opt-in-failed:popup-title']} />
          </Typography>
          <Typography>
            <FormattedMessage
              {...messages['sms-opt-in-failed:popup-description']}
              values={{ smsOptInPhoneNumber, smsOptInKeyword, authMethod }}
            />
          </Typography>
        </Stack>
        <Stack spacing={SizingMultiplier.sm}>
          <Button href={smsOptInLink} component="a" target="_system" onClick={hide}>
            <FormattedMessage {...messages['sms-opt-in-failed:popup-confirm-button-text']} />
          </Button>

          <Typography align="center" py={SizingMultiplier.sm}>
            or
          </Typography>

          <SupportLink>
            <Button onClick={hide} variant="outlined" fullWidth>
              <FormattedMessage {...messages['sms-opt-in-failed:popup-support-button-text']} />
            </Button>
          </SupportLink>

          <Button onClick={hide} variant="text">
            <FormattedMessage {...buttonTextMessages['button-text:cancel']} />
          </Button>
        </Stack>
      </Stack>
    </ModalDrawer>
  );
};
